import overview from './partials/overview.json';
import ingestion from './partials/ingestion.json';
import processing from './partials/processing.json';
import storage from './partials/storage.json';
import fsomon from './fsomon.json';

export default [overview, ingestion, processing, storage, fsomon];
